export const API_URL = import.meta.env.VITE_COUPONS_API_URL
export const API_BASE_URL = `${API_URL}/admin/coupons`
